<template lang="pug">
	.container
		.page-header
			h4(v-on:click="back") 全网球 / 资讯
		.row(style="margin-top: 20px;")
			.col-md-12
				router-view
		.page-footer
			div(style="margin-top: 20px;")
				p 
					a(href="http://www.beian.miit.gov.cn") 沪ICP备15042402号-2 | 
					a(href="http://www.beian.miit.gov.cn") 沪ICP备17014264号-1 | 
					a(href="http://www.beian.miit.gov.cn") 沪ICP备17014264号-2 
	
</template>
<style scoped>
	.container{
		max-width: 700px;
	}
</style>
<script>
	require("bootstrap.min.css")
	module.exports = {
		methods: {
			back () {
				if (this.$route.name != 'index') {
					this.$router.back()
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// app.vue?9c83b5ae